import React from "react";
import { Calculator } from "./Components";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}
